import { themeV5 } from 'theme/v5'


export const pieGraphFormatter = (state, { payload }) => {
  if (!payload) {
    return state
  }

  const possibleLabels = {
    under: 'Under',
    onTrack: 'On Track',
    over: 'Over',
    noData: 'No Data Available',

    diesel: 'Diesel',
    petrol: 'Petrol',
    hybrid: 'Hybrid',
    premiumUnleaded: 'Premium Unleaded',
    electric: 'Electric'
  }

  const possibleColors = {
    under: themeV5.palette.accent.blue,
    onTrack: themeV5.palette.accent.teal,
    over: themeV5.palette.accent.sky,
    noData: themeV5.palette.background.default,

    diesel: themeV5.palette.accent.blue,
    petrol: themeV5.palette.accent.teal,
    hybrid: themeV5.palette.accent.sky,
    electric: themeV5.palette.background.default
  }

  const labels = []
  const colors = []
  const values = []

  const validKeys = Object.keys(payload).filter(k =>
    Object.keys(possibleLabels).includes(k)
  )

  const isFuelAPI = validKeys.includes('petrol') || validKeys.includes('premiumUnleaded')

  let combinedPetrol = null

  if (isFuelAPI) {
    combinedPetrol =
      (payload.petrol ?? 0) + (payload.premiumUnleaded ?? 0)
  }

  validKeys.forEach(key => {
    if (isFuelAPI && key === 'premiumUnleaded') {
      return
    }

    let value = payload[key]
    let finalKey = key

    if (isFuelAPI && key === 'petrol') {
      value = combinedPetrol
      finalKey = 'petrol'
    }

    if (value === null || value === undefined) {
      return
    }

    labels.push(`${possibleLabels[finalKey]}`)
    colors.push(possibleColors[finalKey])
    values.push(value)
  })

  const roundedAverageAge =
    (payload.averageAgeYears === null || payload.averageAgeYears === undefined)
      ? null
      : Math.round(payload.averageAgeYears)

  return {
    ...state,
    data: {
      labels,
      values,
      colors,

      totalFleetSize: payload.fleetSize,
      averageAge: roundedAverageAge,
      passengerPercent: payload.passengerPercent,
      commercialPercent: payload.commercialPercent
    }
  }
}
